// phonics_data_lt04.js
// Letter Teams L04 - L4 Long Vowel u - Magic e - CVCe
// 路由：/phonics/lt04

const MEDIA_BASE = '/media/phonics/lt04';
const V = 'v1';

export const letterDataLt04 = {
  id: 'lt04',
  letter: 'L04',
  title: 'L4 Long Vowel u - Magic e - CVCe',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1)
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3)
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P4-P6: 三段故事（story-video-left-lines-right）
  storySections: [
    {
      label: 'Learn the story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals saw Luke.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "He sat on the mule.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "It's so cute!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Can I sit on the mule?", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "No!", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Pink was sad.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Look! I see a cube!", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
        { en: "There is a tube.", audioEn: `${MEDIA_BASE}/story1_8.mp3?${V}` },
        { en: "I see cups!", audioEn: `${MEDIA_BASE}/story1_9.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "I see pots and lids!", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Let's play a tune!", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "The pals played a tune.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "But the tune was not good!", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Stop! That's a bad tune!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Luke hid in the cube.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Let's play again!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "That's a nice tune!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
      ],
    },
  ],
};
